import styled, { css } from 'styled-components';

import { Text } from '../../../../components';
import { Hint as TextAreaHint } from '../../../../components/TextArea/TextArea.styles';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[20]};
`;

/** One field with its tags, notes and error; `$warn` turns its counter to the warning tone. */
export const FieldBlock = styled.div<{ $warn: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};

  ${(p) =>
    p.$warn &&
    css`
      ${TextAreaHint} {
        color: ${COLORS.warning};
      }
    `}
`;

export const TagRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  flex-wrap: wrap;
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const HintText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.warning};
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.danger};
`;
